<template>
  <div>
    <client-only>
      <loading :active="true" :can-cancel="false" :is-full-page="true"></loading>
    </client-only>
    <div v-if="$fetchState.pending"></div>
    <div v-if="!$fetchState.pending && forceRedirectToCheckoutCartPage()"></div>
  </div>
</template>
<script>
import { createPathOrURLWithQueryParam } from '~/lib/util/page'

export default {
  name: 'MinisiteCartAdd',
  serverCacheKey() {
    return false
  },
  layout: '1ColumnMinisite',
  fetchOnServer: false,
  async fetch() {
    try {
      console.log('MINISITE Entry Point')
      const query = this.$route.query
      console.log('query=', query)
      const { headerPath, minisiteName, productID } = this.$route.query

      this.$store.commit('basket/id', undefined)
      this.$store.commit('basket/payload', undefined)
      this.$store.commit('cart/CartId', undefined)
      this.$store.commit('cart/updatedAt', undefined)
      this.$store.commit('cart/minisite', {
        headerPath,
        minisiteName,
        productID
      })
      this.headerPath = headerPath
      this.minisiteName = minisiteName
      this.productID = productID

      // Get the Product data via the API
      const offerSKU = productID
      let productSKU = minisiteName

      let url = `${this.$config.AWSAPIGatewayURL}/magazine/sku/${offerSKU}`

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url,
        headers: {
          'x-api-key': this.$config.AWSAPIGatewayAPIkey,
          'Cache-Control': 'max-age=0',
          'Content-Type': 'application/json'
        }
      }

      console.info(`GET OFFER by SKU GET URL '${url}'`)

      // Calling the Frontend Api for the Basket (we have axios-cache LRU in place)
      process.env.NODE_ENV !== 'production' && require('axios-debug-log')
      let response = await this.$axios.request(config)

      console.log(`GET /magazine/sku/${offerSKU} RESPONSE=`, response?.data?.payload)
      if (response?.data?.payload) {
        console.log(`OFFER sku ${offerSKU} data=`, response?.data?.payload)
        productSKU = response?.data?.payload?.magazine_name || minisiteName
        // WA for delicious product
        if (productSKU === 'Delicious') {
          productSKU = 'delicious.'
        }
        this.shortsiteCode = response?.data?.payload?.shortsite_code.toLowerCase()
      }

      // ADD to basket
      const data = {
        action: 'add',
        minisite: { headerPath, minisiteName, productID },
        item: {
          product_sku: productSKU,
          offer_sku: offerSKU,
          qty: 1
        }
      }

      url = `${this.$config.AWSAPIGatewayURL}/basket`

      config = {
        method: 'post',
        maxBodyLength: Infinity,
        url,
        headers: {
          'x-api-key': this.$config.AWSAPIGatewayAPIkey,
          'Cache-Control': 'max-age=0',
          'Content-Type': 'application/json'
        },
        data
      }

      console.info(`ADD TO BASKET POST URL '${url}'`)

      // Calling the Frontend Api for the Basket (we have axios-cache LRU in place)
      process.env.NODE_ENV !== 'production' && require('axios-debug-log')
      response = await this.$axios.request(config)

      console.log('RESPONSE=', response?.data?.payload)
      if (response?.data?.payload) {
        console.log('New BASKET=', response?.data?.payload)
        this.$store.commit('basket/payload', response.data.payload)
        this.$store.commit('cart/CartId', response.data.payload.id)
        this.basketID = response.data.payload.id
        this.$store.commit('cart/updatedAt', new Date())
        this.$store.commit('basket/id', response.data.payload.id)
      } else {
        console.error('No payload in response data')
      }
    } catch (e) {
      console.error('minisite/cart/add error=', e)
      this.redirecrURL = createPathOrURLWithQueryParam({ pathOrURL: '/', query: this.$route.query })
    }
  },
  data() {
    return {
      redirecrURL: '/checkout/cart',
      headerPath: undefined,
      minisiteName: undefined,
      productID: undefined,
      basketID: undefined,
      shortsiteCode: undefined
    }
  },
  methods: {
    forceRedirectToCheckoutCartPage() {
      const url = createPathOrURLWithQueryParam({ pathOrURL: `${this.redirecrURL}/${this.basketID}/${this.shortsiteCode}/minisite`, query: this.$route.query })
      console.log('REDIRECT TO=', url)
      window.location.href = url
    }
  }
}
</script>
<style></style>
